var e = {
	detail: {
		unavailable: "This guide isn't available. It may have been removed or unpublished.",
		staysInArea: "Stays in {{destination}}",
		staysNearby: "Stays from this host",
		seeAllStays: "See all"
	},
	moderation: {
		reportTitle: "AI Moderation Report",
		reportEmpty: "No AI report available yet.",
		confidence: "Confidence",
		flags: "Flags ({{count}})",
		noIssues: "No issues flagged."
	},
	article: { previewHint: "Add sections and places from the panel — your guide preview builds here." },
	place: { visitWebsite: "Visit website" },
	card: {
		sectionCount_one: "{{count}} section",
		sectionCount_other: "{{count}} sections",
		placeCount_one: "{{count}} place",
		placeCount_other: "{{count}} places"
	},
	list: {
		title: "Travel Guides",
		subtitle: "Curate local guides of your favourite places for guests.",
		newGuide: "New Guide",
		empty: "No guides yet — create your first one."
	},
	composer: {
		newTitle: "New guide",
		editTitle: "Edit guide",
		loadError: "We couldn't load this guide.",
		backToGuides: "Back to guides",
		submitForReview: "Submit for review",
		toast: {
			saveError: "Could not save",
			submitted: "Submitted for review",
			submitError: "Could not submit"
		},
		basics: {
			stepLabel: "Basics",
			titleLabel: "Title",
			titlePlaceholder: "e.g. A Weekend in Dahab",
			titleRequired: "Title is required",
			locationLabel: "Location",
			locationRequired: "Pick a location",
			selected: "Selected: {{location}}",
			taglineLabel: "Tagline (optional)",
			taglinePlaceholder: "One line that captures the vibe"
		},
		cover: {
			label: "Cover image",
			alt: "cover",
			upload: "Upload cover",
			replace: "Replace cover",
			uploadError: "Could not upload cover"
		},
		section: {
			newPlaceholder: "New section title",
			addError: "Could not add section",
			titlePlaceholder: "Section title",
			intentPlaceholder: "Section description (optional)"
		},
		place: {
			addTitle: "Add place",
			editTitle: "Edit place",
			findOnMaps: "Find on Google Maps",
			nameLabel: "Name",
			namePlaceholder: "Pick a place above",
			nameRequired: "Pick a place from the map first",
			addressLabel: "Address (optional)",
			addressPlaceholder: "Street, city",
			photoLabel: "Photo",
			addPhoto: "Add photo",
			replacePhoto: "Replace photo",
			descriptionLabel: "Description",
			descriptionPlaceholder: "Describe this place…",
			writeWithAi: "Write with AI",
			pickPlaceFirst: "Pick a place first",
			generateError: "Could not generate — try again",
			tagsLabel: "Tags (comma-separated)",
			tagsPlaceholder: "breakfast, coffee, vegetarian",
			websiteLabel: "Website (optional)",
			websitePlaceholder: "https://…",
			save: "Save place",
			saveError: "Failed to save place"
		}
	},
	browse: {
		title: "Travel guides",
		subtitle: "Local guides written by the people who host here.",
		shelfTitle: {
			0: "What to do in {{destination}}",
			1: "{{destination}}, by the people who host there",
			2: "Local favourites in {{destination}}",
			3: "Find your way around {{destination}}",
			4: "Hosts' picks in {{destination}}"
		},
		shelfSubtitle: {
			0: "Places worth your time, chosen by hosts who live nearby.",
			1: "Where the people who host here actually go.",
			2: "Written for guests, by locals.",
			3: "The spots that don't make the usual lists."
		},
		elsewhereTitle: "Further afield",
		elsewhereSubtitle: "Guides from places beyond our main destinations.",
		viewAll: "View all",
		viewAllCount: "View all {{count}}",
		guideCount_one: "{{count}} guide",
		guideCount_other: "{{count}} guides",
		empty: "No published guides yet. Once hosts start writing them, they'll appear here.",
		emptyDestination: "No guides for this destination yet.",
		backToGuides: "All destinations",
		sort: {
			label: "Sort",
			newest: "Newest first",
			places: "Most places"
		}
	},
	map: {
		openPill_one: "{{count}} place on the map",
		openPill_other: "{{count}} places on the map",
		placeCount_one: "{{count}} place",
		placeCount_other: "{{count}} places",
		directionsTo: "Directions to {{place}}",
		collapseList: "Collapse the list"
	}
};
//#endregion
export { e as default };
